import { Button } from 'base/ui/button';
import { DialogLayer } from 'base/ui/dialog';
import { Icon } from 'base/ui/icon';
import {
  IconClear,
  IconCode,
  IconFigma,
  IconReact,
  IconWebflow,
} from 'base/ui/icons';
import {
  TextRegularLight,
  TextSmall,
  TextTiny,
  Title5,
} from 'base/ui/typography';
import classNames from 'classnames';
import React from 'react';
import ExportHeroImage from './export-hero-react.file.webp';
import styles from './export_dialog_react.css';

type Props = {
  onClose: () => void;
};

export const StyleGuideExportReactDialog = ({ onClose }: Props) => {
  return (
    <DialogLayer onClose={onClose}>
      <div className={styles.container}>
        <img src={ExportHeroImage} className={styles.heroImage} />
        <div className={styles.content}>
          <div className={styles.header}>
            <TextSmall color="gradient">Coming soon</TextSmall>
            <div className={styles.heading}>
              <Title5>Export your Style Guide to React and HTML</Title5>
            </div>
            <div className={styles.closeButton}>
              <Button
                icon={IconClear}
                size="large"
                variant="tertiary"
                onClick={onClose}
              />
            </div>
          </div>
          <TextRegularLight>
            We’re busy working on this feature as we speak! In the meantime you
            can still export your wireframes to React and HTML on the Wireframe
            tab.
          </TextRegularLight>
          <div className={styles.features}>
            <div className={styles.featureRow}>
              <div className={styles.featureRowIcon}>
                <Icon icon={IconFigma} />
                <Icon icon={IconWebflow} />
              </div>
              <TextSmall>Export Style Guide</TextSmall>
              <div className={styles.spacer} />
              <div
                className={classNames(
                  styles.featureRowStatus,
                  styles.available,
                )}
              >
                <TextTiny>Available</TextTiny>
              </div>
            </div>
            <div className={styles.featureRow}>
              <div className={styles.featureRowIcon}>
                <Icon icon={IconReact} />
                <Icon icon={IconCode} />
              </div>
              <TextSmall>Export Style Guide</TextSmall>
              <div className={styles.spacer} />
              <div className={styles.featureRowStatus}>
                <TextTiny color="grey">Coming soon</TextTiny>
              </div>
            </div>
          </div>
          <div className={styles.spacer} />
          <div className={styles.footer}>
            <Button variant="primary" label="Got it" onClick={onClose} />
          </div>
        </div>
      </div>
    </DialogLayer>
  );
};
